import styled from 'styled-components';

import InsightsTabsFilterBar from 'components/insights/filterBar/InsightsTabsFilterBar';
import Page from 'components/layouts/page/Page';

// Placeholder page: renders the shared insights header (desktop + mobile, with the mobile
// hamburger menu) so the shell matches the sibling insights dashboards. Tabs/filters/date
// wiring is inert until the store is added in the dashboard build ticket.
export default function InboundReferralsInsightsPage() {
  return (
    <Page>
      <StyledPageHeader>
        <InsightsTabsFilterBar
          title='Inbound Referral Dashboard'
          gtmPrefix='inboundReferralsDashboard'
          filters={{}}
          filterSections={[]}
          setSelectedFilters={() => {}}
        />
      </StyledPageHeader>
    </Page>
  );
}

const StyledPageHeader = styled(Page.Header)`
  background: none;
  border-bottom: none;
`;
